import { combineEpics } from "redux-observable";

// import views from "../features/views/epics";

export default combineEpics({});
